// Enabled by default for the funding_v2 release; set false to use the legacy path.
export const FUNDING_V2_ENABLED = process.env.VUE_APP_FUNDING_V2_ENABLED !== 'false';
